import {SortDirection as SortDirectionType} from "react-virtualized/dist/es/";

interface SortKeyDirection{
    key: string;
    direction: SortDirection;
}

enum SortDirection {
    Asc = "asc",
    Desc = "desc"
}
 
class SortDirectionUtil {

    static toReactVirtuatlized(sortDirection: SortDirection): SortDirectionType {
        return sortDirection == SortDirection.Asc ? "ASC" : "DESC";
    }

    static toSortDirection(rvSort: SortDirectionType): SortDirection {
        return rvSort == "ASC" ? SortDirection.Asc : SortDirection.Desc;
    }

}

export {SortDirection, SortDirectionUtil, SortKeyDirection}